import tw from '../../../helpers/tailwind';

const MultiLayeredWaves = ({ className, isDark = false }) => {
  return (
    <svg
      id="visual"
      viewBox="0 0 1000 100"
      width="1000"
      height="100"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      version="1.1"
      preserveAspectRatio="none"
      className={tw('w-full h-full', className)}
    >
      <rect
        x="0"
        y="0"
        width="1000"
        height="100"
        className={isDark ? 'fill-themeDarkGrey' : 'fill-themeLightGrey'}
      ></rect>
      <path
        d="M0 24L41.7 23.3C83.3 22.7 166.7 21.3 250 21.5C333.3 21.7 416.7 23.3 500 20.3C583.3 17.3 666.7 9.7 750 12C833.3 14.3 916.7 26.7 958.3 32.8L1000 39L1000 101L958.3 101C916.7 101 833.3 101 750 101C666.7 101 583.3 101 500 101C416.7 101 333.3 101 250 101C166.7 101 83.3 101 41.7 101L0 101Z"
        className="fill-themeGrey"
      ></path>
      <path
        d="M0 25L41.7 25.2C83.3 25.3 166.7 25.7 250 31.5C333.3 37.3 416.7 48.7 500 55.3C583.3 62 666.7 64 750 59.3C833.3 54.7 916.7 43.3 958.3 37.7L1000 32L1000 101L958.3 101C916.7 101 833.3 101 750 101C666.7 101 583.3 101 500 101C416.7 101 333.3 101 250 101C166.7 101 83.3 101 41.7 101L0 101Z"
        className={isDark ? 'fill-black' : 'fill-themeDarkGrey'}
      ></path>
      <path
        d="M0 66L41.7 63.2C83.3 60.3 166.7 54.7 250 53.8C333.3 53 416.7 57 500 65.2C583.3 73.3 666.7 85.7 750 87.5C833.3 89.3 916.7 80.7 958.3 76.3L1000 72L1000 101L958.3 101C916.7 101 833.3 101 750 101C666.7 101 583.3 101 500 101C416.7 101 333.3 101 250 101C166.7 101 83.3 101 41.7 101L0 101Z"
        className="fill-mint"
      ></path>
    </svg>
  );
};

export default MultiLayeredWaves;
